import request from '../../utils/request';

export interface ITokenUsageLog {
  id: number;
  service: string;
  model: string;
  input_tokens: number;
  output_tokens: number;
  tenant_id: number | null;
  executed_at: string;
}

export interface ITokenUsageResult {
  data: ITokenUsageLog[];
  count: number;
  page: number;
  limit: number;
  totalInputTokens: number;
  totalOutputTokens: number;
}

export interface ITokenSummary {
  totals: { input_tokens: number; output_tokens: number; call_count: number };
  by_service: { service: string; input_tokens: number; output_tokens: number; call_count: number }[];
  by_model: { model: string; input_tokens: number; output_tokens: number; call_count: number }[];
  daily: { date: string; input_tokens: number; output_tokens: number }[];
}

export interface IModelPricing {
  model: string;
  input_cost_per_1m: number;
  output_cost_per_1m: number;
  is_active: boolean;
  updated_at: string | null;
}

class AiTokenUsageService {
  list = async (page = 1, limit = 50, service?: string, model?: string, sort?: 'date' | 'tokens'): Promise<ITokenUsageResult> => {
    const params: Record<string, any> = { page, limit };
    if (service) params.service = service;
    if (model) params.model = model;
    if (sort) params.sort = sort;
    const res = await request({ url: '/ai-token-usage', method: 'GET', params });
    return res.data.body.data;
  };

  summary = async (days = 30): Promise<ITokenSummary> => {
    const res = await request({ url: '/ai-token-usage/summary', method: 'GET', params: { days } });
    return res.data.body.data;
  };

  getPricing = async (): Promise<IModelPricing[]> => {
    const res = await request({ url: '/ai-token-usage/pricing', method: 'GET' });
    return res.data.body.data;
  };

  upsertPricing = async (
    model: string,
    inputCostPer1M: number,
    outputCostPer1M: number,
    isActive: boolean,
  ): Promise<IModelPricing> => {
    const res = await request({
      url: '/ai-token-usage/pricing',
      method: 'POST',
      data: { model, input_cost_per_1m: inputCostPer1M, output_cost_per_1m: outputCostPer1M, is_active: isActive },
    });
    return res.data.body.data;
  };
}

export default new AiTokenUsageService();
